import { colors } from '../../colors';
var address = {
  arrowColor: colors.copper,
  textColor: colors.lead,
  borderColor: colors.lead,
  backgroundColor: colors.white
};
export default address;